import { initializeApp, getApps } from "firebase/app";
import { browserLocalPersistence, connectAuthEmulator, getAuth, setPersistence } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { appEnv } from "@core/config/env";

const app = getApps().length > 0
  ? getApps()[0]!
  : initializeApp({
      apiKey: appEnv.firebase.apiKey,
      authDomain: appEnv.firebase.authDomain,
      projectId: appEnv.firebase.projectId,
      storageBucket: appEnv.firebase.storageBucket,
      appId: appEnv.firebase.appId,
      messagingSenderId: appEnv.firebase.messagingSenderId,
      measurementId: appEnv.firebase.measurementId
    });

const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(() => {
  /* persistence best-effort */
});
auth.useDeviceLanguage();

const firestore = getFirestore(app);
const functions = getFunctions(app, appEnv.firebase.region);

if (appEnv.firebase.useEmulators) {
  try {
    connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
    connectFirestoreEmulator(firestore, "127.0.0.1", 8080);
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  } catch (error) {
    console.warn("Failed to connect to Firebase emulators", error);
  }
}

export const firebase = {
  app,
  auth,
  firestore,
  functions
};

export type FirebaseServices = typeof firebase;

